import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { apiKey } from "../config/config";
import { toast, ToastContainer } from "react-toastify";
import Table from "../components/Table";

export default function BranchContractApplications({ lang = {} }) {
  const [applications, setApplications] = useState([]);
  // const [loading, setLoading] = useState(true);
  const [selectedApp, setSelectedApp] = useState(null);
  const [rejectionReason, setRejectionReason] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const navigate = useNavigate();

  const session = JSON.parse(sessionStorage.getItem("aman-admin") || "{}");
  const adminObj = JSON.parse(session.admin || "{}");
  const branchId = adminObj.branch_id;
  const token = adminObj.token;
  const lightMode = adminObj.light_mode === "yes";

  const columns = [
    {
      header: lang["SN"],
      cell: row => row.row.index + 1
    },
    {
      header: lang["Customer_Name"],
      accessorKey: 'customer_name'
    },
    {
      header: lang["Identity_Number"],
      accessorKey: 'customer_national_id',
    },
    {
      header: lang["Mobile_Number"],
      accessorKey: 'customer_phone'
    },
    {
      header: lang["Contract_Type"],
      accessorKey: 'contract_type'
    },
    {
      header: lang["Item_Name"],
      accessorKey: 'item_name'
    },
    {
      header: lang["Amount"],
      accessorKey: 'total_amount'
    },
    {
      header: lang["Status"],
      accessorKey: 'status',
      cell: row => row.getValue() === "approved" ? <span className="badge rounded-pill bg-success">{lang['approved'] || "Approved"}</span> : row.getValue() === "rejected" ? <span className="badge rounded-pill bg-danger">{lang['rejected'] || "Rejected"}</span> : <span className="badge rounded-pill bg-warning">{lang['pending'] || "Pending"}</span>
    },
    {
      header: lang["Actions"],
      accessorKey: "created_contract_id",
      cell: row => (
        <div className="btn-group">
          {row.getValue() ? (
            <button
              className="btn btn-sm btn-success fw-bold"
              onClick={() => navigate(`/dashboard/customer/contract-information/${row.getValue()}`)}
            >
              <i className="fa fa-eye me-1" /> View Contract
            </button>
          ) : (
            <button
              className="btn btn-sm btn-outline-primary fw-bold"
              data-bs-toggle="modal"
              data-bs-target="#appReviewModal"
              onClick={() => setSelectedApp(row.row.original)}
            >
              Review & Action
            </button>
          )}
        </div>
      )
    }
  ];

  const fetchApplications = React.useCallback(() => {
    if (!branchId || !token) return;

    // setLoading(true);

    axios
      .get(`${apiKey}/dealer-panel/branch-applications/${branchId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setApplications(res.data.applications || []);
        // setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        // setLoading(false);
      });
  }, [branchId, token]);

  useEffect(() => {
    fetchApplications();
  }, [fetchApplications]);

  const handleRejectApplication = (appId) => {
    if (!token) return;

    setSubmitting(true);

    axios
      .put(
        `${apiKey}/dealer-panel/application-status/${appId}`,
        { status: "rejected", rejection_reason: rejectionReason },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then((res) => {
        setSubmitting(false);
        toast.success("Application rejected successfully");
        setRejectionReason("");
        setSelectedApp(null);
        document.getElementById("closeAppModalButton")?.click();
        fetchApplications();
      })
      .catch((err) => {
        setSubmitting(false);
        console.error(err);
        toast.error("Failed to reject application.");
      });
  };

  const handleProceedWithContract = (app) => {
    if (!token) return;

    // If contract already created for this application, navigate to view contract
    if (app.created_contract_id) {
      document.getElementById("closeAppModalButton")?.click();
      navigate(`/dashboard/customer/contract-information/${app.created_contract_id}`);
      return;
    }

    setSubmitting(true);

    axios
      .put(
        `${apiKey}/dealer-panel/application-status/${app.id}`,
        { status: "approved" },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then((res) => {
        setSubmitting(false);
        const customerId = res.data.customer_id || app.customer_id;
        const isFuture = app.contract_type === "future";

        const targetPath = lightMode
          ? isFuture
            ? "/dashboard/contracts/future/light-contract"
            : "/dashboard/contracts/light-contract"
          : isFuture
          ? "/dashboard/contracts/future/light-contract"
          : "/dashboard/contracts/light-contract";

        const queryParams = new URLSearchParams({
          application_id: app.id,
          customer: customerId,
          item_name: app.item_name || "",
          quantity: app.quantity || 1,
          unit_price: app.unit_price || "",
          total_amount: app.total_amount || "",
          no_installments: app.no_of_installments || 1,
          notes: app.notes || "",
        }).toString();

        document.getElementById("closeAppModalButton")?.click();
        toast.success("Application approved! Opening contract creation form...");
        setTimeout(() => {
          navigate(`${targetPath}?${queryParams}`);
        }, 600);
      })
      .catch((err) => {
        setSubmitting(false);
        console.error(err);
        toast.error("Failed to approve application.");
      });
  };

  return (
    <div className="container-fluid px-4 py-3">
      <ToastContainer />
      <div className="pagetitle mb-4">
        <h1 className="fw-bold">{lang["Contract Applications"] || "Contract Applications"}</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">{lang["Dashboard"] || "Dashboard"}</li>
            <li className="breadcrumb-item active">{lang["Contract Applications"] || "Contract Applications"}</li>
          </ol>
        </nav>
      </div>

      <section className="section">
          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="row pt-3">
                  <div className="rr col-9">
                    {lang["Contract Application List"] || "Contract Application List"}
                  </div>
                </div>
                <div className="card-body">
                  <div classNames="d-flex mt-3 mb-3">
                    <Table
                    columns={columns}
                    data={applications}
                    lang={lang}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

      {/* Application Review Modal */}
      <div className="modal fade" id="appReviewModal" tabIndex="-1" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content border-0 shadow-lg rounded-4">
            <div className="modal-header bg-primary text-white">
              <h5 className="modal-title fw-bold">
                Review Application #{selectedApp?.id}
              </h5>
              <button
                id="closeAppModalButton"
                type="button"
                className="btn-close btn-close-white"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body p-4">
              {selectedApp && (
                <>
                  <div className="bg-light p-3 rounded-3 border mb-3">
                    <div className="mb-2">
                      <span className="small text-muted d-block">Customer:</span>
                      <strong>{selectedApp.customer_name} ({selectedApp.customer_phone})</strong>
                    </div>
                    <div className="mb-2">
                      <span className="small text-muted d-block">Contract Type:</span>
                      <strong className="text-capitalize">{selectedApp.contract_type === "future" ? "Future (آجل)" : "Installment (تقسيط)"}</strong>
                    </div>
                    {selectedApp.item_name && (
                      <div className="mb-2">
                        <span className="small text-muted d-block">Selected Item:</span>
                        <strong>{selectedApp.item_name} (Qty: {selectedApp.quantity || 1})</strong>
                      </div>
                    )}
                    <div className="mb-2">
                      <span className="small text-muted d-block">Total Contract Amount:</span>
                      <strong className="text-primary fs-5">SAR {Number(selectedApp.total_amount).toLocaleString()}</strong>
                    </div>
                    <div className="mb-2">
                      <span className="small text-muted d-block">Installments Count:</span>
                      <strong>{selectedApp.contract_type === "future" ? "1 Single Payment" : `${selectedApp.no_of_installments || selectedApp.months || 12} Installments`}</strong>
                    </div>
                    {selectedApp.notes && (
                      <div>
                        <span className="small text-muted d-block">Customer Notes:</span>
                        <p className="small mb-0 text-secondary">{selectedApp.notes}</p>
                      </div>
                    )}
                  </div>

                  {selectedApp.created_contract_id ? (
                    <div className="alert alert-success text-center mb-0">
                      <p className="mb-2 fw-bold">Contract #{selectedApp.created_contract_id} has been created for this application.</p>
                      <button
                        className="btn btn-success btn-sm fw-bold px-4"
                        onClick={() => {
                          document.getElementById("closeAppModalButton")?.click();
                          navigate(`/dashboard/customer/contract-information/${selectedApp.created_contract_id}`);
                        }}
                      >
                        <i className="fa fa-eye me-1"></i> View Created Contract
                      </button>
                    </div>
                  ) : selectedApp.status === "pending" ? (
                    <>
                      <div className="mb-3">
                        <label className="form-label small fw-bold text-secondary">
                          Rejection Reason (Required if rejecting)
                        </label>
                        <textarea
                          className="form-control"
                          rows="2"
                          placeholder="Specify reason if rejecting application..."
                          value={rejectionReason}
                          onChange={(e) => setRejectionReason(e.target.value)}
                        ></textarea>
                      </div>

                      <div className="d-flex justify-content-between gap-2 mt-4">
                        <button
                          type="button"
                          className="btn btn-danger flex-grow-1 fw-bold"
                          disabled={submitting}
                          onClick={() => handleRejectApplication(selectedApp.id)}
                        >
                          Reject Application
                        </button>
                        <button
                          type="button"
                          className="btn btn-success flex-grow-1 fw-bold"
                          disabled={submitting}
                          onClick={() => handleProceedWithContract(selectedApp)}
                        >
                          <i className="fa fa-arrow-right me-1"></i> Proceed with Contract
                        </button>
                      </div>
                    </>
                  ) : (
                    <div className="d-flex justify-content-between align-items-center">
                      <span className="badge bg-info p-2">Application Approved</span>
                      <button
                        className="btn btn-primary btn-sm fw-bold"
                        onClick={() => handleProceedWithContract(selectedApp)}
                      >
                        <i className="fa fa-file-signature me-1"></i> Proceed to Create Contract
                      </button>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
